import { Head } from '@inertiajs/react'
import { Title } from '@mantine/core'

export default function HomePage() {
  return (
    <>
      <Head title="Home" />
      <div style={{ padding: 'var(--mantine-spacing-xl)' }}>
        <Title order={1} mb="lg">
          Welcome to Seamflow
        </Title>
      </div>
    </>
  )
}
